import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { AppSettings } from 'src/app/app-settings';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EventosService } from 'src/app/services/eventos.service';

@Component({
  selector: 'app-router-events',
  templateUrl: './router-events.component.html',
  styleUrls: ['./router-events.component.scss']
})
export class RouterEventsComponent implements OnInit, OnDestroy {

  event!: any;
  profile!: any;
  title!: any;
  nameTab: string = 'Información del evento';
  numberTab: number = 1;
  isDraftEvent: boolean = false;
  eventType: 'informative' | 'external' | 'normal' | null = null;

  allowCreate!: any;
  isDraft: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private eventosService: EventosService,
    private auth: AuthenticationService, private apiEvents: EventosService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.profile = this.auth.getProfile();
    let url = location.pathname.split('/');
    this.isDraftEvent = location.pathname.indexOf('draft/detail/') != -1;
    let idEvent = +url[url.length - 1];
    this.event = idEvent;
    this.syncTabWithRoute(location.pathname);
    this.eventosService.setEventPanel(+idEvent);
    this.eventosService.getEventById(idEvent).subscribe({
      next: (data) => {
        this.isDraft = data.data.draft;
        this.title = data.data.title;
        this.eventType = data.data.informative ? 'informative' : (data.data.external ? 'external' : 'normal');
      }
    });

    let rolesProfile = this.auth.getProfile()?.roles.map((role: any) => role.name);
    this.allowCreate = rolesProfile?.includes('superadmin');
    // this.allowCreate = rolesProfile?.find((element) => (element == 'ACCESS_CLOUD' || element == 'ACCOUNT_OWNER' || element == 'ACCESS_EXTERN_EVENTS' || element == 'ACCESS_ADMIN' || element == 'ACCESS_MANAGER'));
    // rolesProfile?.forEach(element => {
    //   if (element == 'admin' || element == 'superadmin' || element == 'ACCESS_CLOUD' || element == 'ACCOUNT_OWNER' || element == 'ACCESS_EXTERN_EVENTS' || element == 'ACCESS_ADMIN' || element == 'ACCESS_MANAGER' || element == 'CREATE_EVENTS') {
    //     this.allowCreate = true;
    //   }
    // });
  }

  ngAfterViewInit() {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        var url = event.url;
        this.syncTabWithRoute(url);
      }
    });
  }

  changeMenuEvent(event: any) {
    this.nameTab = event.name;
    this.numberTab = event.tab;
  }

  goBack() {
    this.router.navigate(['/panel-control/events']);
  }

  ngOnDestroy(): void {
    // Limpiar filtros solo si el usuario NO está navegando dentro de eventos
    if (!this.router.url?.includes('/panel-control/events')) {
      this.eventosService.clearEventsPanelFilters();
    }
  }

  private syncTabWithRoute(url: string) {
    const cleanUrl = (url || '').split('?')[0];
    const tabsByRoute: Array<{ key: string; tab: number; name: string }> = [
      { key: '/info-event/', tab: 1, name: 'Información del evento' },
      { key: '/lugar-event/', tab: 2, name: 'Lugar y aforo' },
      { key: '/config-event/', tab: 3, name: 'Configuración del evento' },
      { key: '/multimedia-event/', tab: 4, name: 'Multimedia' },
      { key: '/sessions-event/', tab: 5, name: 'Sesiones' },
      { key: '/ticket-event/', tab: 6, name: 'Entradas' },
      { key: '/discount-event/', tab: 7, name: 'Descuentos / Abonos' },
      { key: '/sale-config-event/', tab: 8, name: 'Configuración de venta' },
      { key: '/order-event/', tab: 9, name: 'Pedidos del evento' },
      { key: '/report-event/', tab: 10, name: 'Informes del evento' },
      { key: '/mailing-event/', tab: 11, name: 'Envío de comunicaciones' },
      { key: '/comment-event/', tab: 12, name: 'Gestión de comentarios' },
    ];

    const matchedTab = tabsByRoute.find((tabConfig) =>
      cleanUrl.includes(tabConfig.key),
    );

    if (matchedTab) {
      this.numberTab = matchedTab.tab;
      this.nameTab = matchedTab.name;
    }
  }

  changeActionMap(save: boolean) {
    this.apiEvents.saveMapAction(save);
  }

  openLinkEvent() {
    let titleUrl = this.title?.replace(/[^\w\s]/g, '-').replace(/\s+/g, '-').replace(/-{2,}/g, '-').replace(/-{3,}/g, '-');
    if (titleUrl?.charAt(titleUrl.length - 1) === '-') titleUrl = titleUrl.slice(0, -1);
    let url = `${AppSettings.FRONT}`;
    if (this.isDraft) {
      url += '/draft';
    }
    url += `/event/${this.event + '-' + titleUrl?.toLowerCase()}`;
    return url;
    // window.open(url, '_blank');
  }

  copyLink() {
    const link = this.openLinkEvent(); // Obtén el enlace desde la función
    navigator.clipboard.writeText(link).then(() => {
      this.infoDialog('¡Enlace copiado al portapapeles!');
    });
  }

  infoDialog(msg: string) {
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: msg,
        btnCancel: false
      }
    });
  }

}
